module.exports = __webpack_public_path__ + "store03.jpg?574114d5e76aa014703ac009ae77e429";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store03.jpg
// module id = 332
// module chunks = 0